import React, { useState, useEffect } from 'react';
import { Stack, Paper, Typography, Divider, ToggleButtonGroup, ToggleButton, Chip } from '@mui/material';
import BasicDetailsForm from './sections/BasicDetailsForm';
import CrmRelatedPropertiesForm from './sections/CrmRelatedPropertiesForm'; // Import the new component
import CaseDetailsHistory from './CaseDetailsHistory';
import PregnancyDetails from './sections/PregnancyDetails';


/**
 * Main case details form component that combines all sections
 */
const CaseDetailsForm = ({ caseData, updateCaseData }) => {

  /**
   * Need two modes for toggle button group
   * 1. Details
   * 2. History
   */
  const [viewMode, setViewMode] = useState("details");

  const toggleViewMode = (mode) => {
    setViewMode(mode);
  }

  return (
    <Stack
      flex={1}
      flexGrow={1}
      component={Paper}
      elevation={2}
      direction={"column"}
      sx={{
        backgroundColor: 'background.paper',
        pb: 5
      }}
    >
      <Stack direction={{
        xs: "column",
        md: "row"
      }} justifyContent={"space-between"} px={2} py={1}>
        <Stack direction={"column"}>
          <Typography>
            Mother ID:
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="h6" gutterBottom sx={{ mb: 0 }}> {/* Remove default bottom margin */}
              {caseData.motherID}
            </Typography>
            {/* TODO: Replace 'caseData.status' with the actual status property if different */}
            {caseData.badData === true && (
              <Chip label="Bad Data" color="error" size="small" />
            )}
            {caseData.completed === true && (
              <Chip label="Completed" color="success" size="small" />
            )}
          </Stack>
        </Stack>
        <Stack direction={"column"}>
          <Typography>
            Currently Allocated To:
          </Typography>
          <Typography variant="h6" gutterBottom>
            {caseData?.allocatedToUser?.name || "N/A"}
          </Typography>
        </Stack>
      </Stack>
      <Divider />

      <Stack px={2} py={1}>
        <ToggleButtonGroup
          value={viewMode}
          onChange={(event, newViewMode) => toggleViewMode(newViewMode)}
          exclusive
          aria-label="view mode"
          fullWidth
        >
          <ToggleButton value="details">Details</ToggleButton>
          <ToggleButton value="history">History</ToggleButton>
        </ToggleButtonGroup>
      </Stack>
      <Divider />

      {/* Top bar displaying motherID and name */}
      {/* Need different sections */}

      {/* Basic Details Form */}
      {viewMode === "details" && (
        <Stack direction={"column"} spacing={2}>
          {caseData && (
            <>
              <BasicDetailsForm caseData={caseData} updateCaseData={updateCaseData} />
              {/* Add the new CRM form section */}
              <CrmRelatedPropertiesForm caseData={caseData} updateCaseData={updateCaseData} />

              {/*Add Pregnancy Details */}
              <PregnancyDetails caseData={caseData} updateCaseData={updateCaseData} />
            </>
          )}
        </Stack>
      )}

      {/* History Form */}
      {viewMode === "history" && (
        <Stack direction={"column"} spacing={2}>
          <CaseDetailsHistory caseData={caseData} />
        </Stack>
      )}
    </Stack>
  );
};

export default CaseDetailsForm;
